import { LoaderCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import PostCard from "./PostCard";
import type { Persona } from "@/api/personas";
import type { Post } from "@/api/posts";

interface PostsTabProps {
  isLoading: boolean;
  posts: Post[];
  personaData: Persona;
  onRefresh: () => Promise<void>;
  isRefreshing: boolean;
}

const PostsTab: React.FC<PostsTabProps> = ({
  isLoading,
  posts,
  personaData,
  onRefresh,
  isRefreshing,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-10">
        <LoaderCircle className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <Card>
        <CardContent className="py-6 text-center">
          <p className="text-muted-foreground">No entries found</p>
          <button
            onClick={onRefresh}
            className="text-sm text-primary mt-2 underline"
            disabled={isRefreshing}
          >
            {isRefreshing ? "Refreshing..." : "Refresh to check again"}
          </button>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6 my-4">
      {posts.map((post) => (
        <PostCard key={post.doc_id} post={post} personaData={personaData} />
      ))}
    </div>
  );
};

export default PostsTab;
